/**
 * usePanelLayout — research's binding of the shared panel-surface hook.
 *
 * The hook lives in `shared/surface/usePanelSurface`; this fixes it to the
 * research config so components here call it with no arguments, exactly as
 * before.
 */

import usePanelSurface, {
  UsePanelSurfaceResult,
} from '../../shared/surface/usePanelSurface';
import { PanelId, RESEARCH_SURFACE } from './layout';

export type UsePanelLayoutResult = UsePanelSurfaceResult<PanelId>;

export function usePanelLayout(): UsePanelLayoutResult {
  return usePanelSurface(RESEARCH_SURFACE);
}

export default usePanelLayout;
